import { client } from "./client";
import interceptors from "./interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSchedules(params) {
	return client.get("api/po-schedule/data", {
		params: params,
	});
}

function getSchedulesAll(params) {
	return client.get("api/po-schedule/all", {
		params: params,
	});
}

function exportSchedules(params) {
	return client.get("api/po-schedule/export", {
		params: params,
	});
}

function exportSchedulesAll(params) {
	return client.get("api/po-schedule/export-all", {
		params: params,
	});
}
export default {
	getSchedules,
	getSchedulesAll,
	exportSchedules,
	exportSchedulesAll
};